import { formatMetric } from '../panelConfig';

/** Top productos del período por revenue (ecommerce): Nombre — Revenue — Órdenes. */
export default function TopSkusTable({ skus }) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-gray-700">Top 10 productos</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-left text-xs uppercase tracking-wide text-gray-500">
              <th className="py-2 pr-3 font-medium">Nombre</th>
              <th className="py-2 pr-3 text-right font-medium">Revenue</th>
              <th className="py-2 text-right font-medium">Órdenes</th>
            </tr>
          </thead>
          <tbody>
            {skus.map((s) => (
              <tr key={s.sku} className="border-b border-gray-100 last:border-0">
                <td className="py-2 pr-3 text-gray-900">
                  {s.product_name || s.sku}
                  {s.product_name && (
                    <span className="ml-2 text-xs text-gray-400">{s.sku}</span>
                  )}
                </td>
                <td className="py-2 pr-3 text-right font-medium text-gray-900">
                  {formatMetric(s.revenue, 'currency')}
                </td>
                <td className="py-2 text-right text-gray-700">
                  {formatMetric(s.orders, 'number')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
